import { render, staticRenderFns } from "./TerminalRegisterForm.vue?vue&type=template&id=a0627d5c&scoped=true"
import script from "./TerminalRegisterForm.vue?vue&type=script&lang=js"
export * from "./TerminalRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0627d5c",
  null
  
)

export default component.exports